import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Swal from 'sweetalert2';
import { getVenues, destroyVenue } from '../../../api/VenuesAPI';
import AppBreadCrumb from '../../../components/common/AppBreadCrumb';
import AppPaginator from '../../../components/AppPaginator';
import AppSearchBox from '../../../components/AppSearchBox';
import PerPageBlock from '../../../components/common/PerPageBlock';
import AppToaster from '../../../components/AppToaster';

const VenuesPage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const successMessage = location.state?.message;

    const [venuesList, setVenuesList] = useState({ data: [], per_page: 15, last_page: 0 });
    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(15);
    const [searchTerm, setSearchTerm] = useState('');
    const [searchTermCompleted, setSearchTermCompleted] = useState('');
    const [isLoading, setIsLoading] = useState(true);
    const [triggerFetch, setTriggerFetch] = useState(false);
    const [showToaster, setShowToaster] = useState(false);
    const [toaster, setToaster] = useState({});

    useEffect(() => {
        if (successMessage) {
            setShowToaster(true);
            setToaster({ type: 'success', heading: 'Success!', message: successMessage });
            navigate(location.pathname, { replace: true });
        }
    }, [successMessage, location.pathname, navigate]);

    useEffect(() => {
        setIsLoading(true);
        const filters = { page: currentPage, per_page: perPage, search_term: searchTermCompleted };
        getVenues(filters, (response) => {
            setIsLoading(false);
            if (response.venues) {
                setVenuesList(response.venues);
            }
        });
    }, [currentPage, perPage, searchTermCompleted, triggerFetch]);

    const handleAddClick = () => navigate('/club_portal/venues/create');
    const handleEditClick = (id) => navigate(`/club_portal/venues/edit/${id}`);

    const handleDeleteClick = (venue) => {
        Swal.fire({
            title: 'Are you sure?',
            html: `<p>You are about to delete the venue: <strong>${venue.name}</strong></p><p>This action cannot be undone.</p>`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
            if (result.isConfirmed) {
                destroyVenue(venue, (response) => {
                    if (response.venue) {
                        Swal.fire('Deleted!', 'The venue has been deleted.', 'success');
                        setTriggerFetch(prev => !prev);
                    } else {
                        Swal.fire('Error!', response?.response?.data?.message || 'Could not delete the venue.', 'error');
                    }
                });
            }
        });
    };

    return (
        <>
            <AppToaster showToaster={showToaster} setShowToaster={setShowToaster} toaster={toaster} />
            <main>
                <div className="container-fluid">
                    <AppBreadCrumb title="Venues" />
                    <div className="row">
                        <div className="col-12">
                            <div className="tab-wrapper mb-3">
                                <ul className="tabs">
                                    <li className="tab-link active">All Venues</li>
                                    <li className="ms-md-auto">
                                        <div className="text-md-end d-flex flex-column flex-md-row align-items-md-center p-2">
                                            <AppSearchBox searchTerm={searchTerm} setSearchTerm={setSearchTerm} setSearchTermCompleted={setSearchTermCompleted} />
                                            <button className="text-nowrap btn btn-primary btn-sm mt-2 mt-md-0 ms-md-3 fw-semibold f-s-14" type="button" onClick={handleAddClick}>
                                                <i className="ti ti-plus f-s-18"></i> Add Venue
                                            </button>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            <div className="content-wrapper">
                                <div className="d-flex m-md-3">
                                    {venuesList.data.length > 0 && (
                                        <>
                                            <AppPaginator entityName="Venues" currentPage={currentPage} totalPages={venuesList.last_page} setCurrentPage={setCurrentPage} />
                                            <PerPageBlock perPage={perPage} setPerPage={setPerPage} />
                                        </>
                                    )}
                                    {isLoading && <div className="loader_box ms-auto"><div className="loader_14"></div></div>}
                                did </div>
                                <div className="tabs-content active">
                                    <div className="row">
                                        {!isLoading && (
                                            venuesList.data.length > 0 ? venuesList.data.map(venue => (
                                                <div className="col-md-6 col-xl-4 project-card" key={venue.id}>
                                                    <div className="card hover-effect">
                                                        <div className="card-header">
                                                            <div className="d-flex align-items-center">
                                                                <div className="h-40 w-40 d-flex-center b-r-50 overflow-hidden bg-light-primary text-primary">
                                                                    <i className="fas fa-map-marker-alt fa-lg"></i>
                                                                </div>
                                                                <div className="flex-grow-1 ps-2">
                                                                    <h6 className="m-0 text-dark f-w-600">{venue.name}</h6>
                                                                </div>
                                                                <div className="dropdown">
                                                                    <button aria-expanded="false" className="bg-none border-0" data-bs-toggle="dropdown" type="button">
                                                                        <i className="ti ti-dots-vertical text-dark" />
                                                                    </button>
                                                                    <ul className="dropdown-menu dropdown-menu-end">
                                                                        <li><a className="dropdown-item" onClick={() => handleEditClick(venue.id)}><i className="ti ti-edit text-success" /> Edit</a></li>
                                                                        <li><a className="dropdown-item delete-button" onClick={() => handleDeleteClick(venue)}><i className="ti ti-trash text-danger" /> Delete</a></li>
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="card-body">
                                                            <div className="d-flex">
                                                                <div>
                                                                    <h6 className="text-dark f-s-14">Location: <span className="text-primary">{venue.location || 'N/A'}</span></h6>
                                                                </div>
                                                                <div className="flex-grow-1 text-end">
                                                                    <p className="f-w-500 text-secondary">Id</p>
                                                                    <h6 className="f-w-600">{venue.id}</h6>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )) : (
                                                <div className="card mb-3 hover-effect">
                                                    <div className="row g-0">
                                                        <div className="col-md-6 col-xl-8"><div className="card-body"><h5 className="card-title">No Venues Found</h5><p className="card-text">No records found. Click "Add Venue" to get started.</p></div></div>
                                                        <div className="col-md-6 col-xl-4"><img alt="No data illustration" className="img-fluid" src="/assets/images/blog-app/09.jpg" /></div>
                                                    </div>
                                                </div>
                                            )
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </>
    );
};

export default VenuesPage;

